module.exports = __webpack_public_path__ + "img/xxings.dd6ad94a.png";